//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import parse from 'date-fns/parse'
import format from 'date-fns/format'



import slugify from 'slugify';

export default {
  props: {
    
  },
  components: {

  },
  computed: {
    inclusions: function() {

      return featuredPosts.join(',');

    }
  },
  watch: {

  },
  filters: {

  },
  data() {
    return { 
      
      loading: true,
      ui: {
        page: 1,
        per_page: 3,
      },
      stories: [],
      sliderOptions: {
          initialIndex: 0,
          wrapAround: true,
          resize: true,
          setGallerySize: false,
          autoPlay: 4000
          // any options from Flickity can be used
      },
      fittyOptions: {
        minSize: 28,
        maxSize: 36,
      },
      postApiKey: postApiKey,
      featuredPosts: featuredPosts
    }
  },
  mounted() {

    let self = this;


    this.getPosts(function() {

  

    });
   
 

  },
  methods: {
    urlTitle: function(post) {

      return post.id + '-' + slugify(post.title, { remove: /[*+~.()'"!,:@]/g });

    },
    printDate(dt, ps, fm) {
      return format( parse(dt, ps, new Date()), fm );
    },
    getPadded(num, size) {
      var s = String(num);
      while (s.length < (size || 2)) {s = "0" + s;}
      return s;
    },
    getPosts(callback) {

    

      let data = {
        //api_key: '092c303b01004fe53d118bc9a2a03a2f',
        api_key: this.postApiKey,
        page: this.ui.page,
        pp: 3,
        view_type: 'list',
        //search_domain: 'https://visitmeckva.com/local-stories',
        layout: 'grid',
        sort_by: 'newest',
        show_featured: false,
        search_term: '',
        view_type_default: 'grid',
        include: this.featuredPosts
      };

      let url = 'https://api.everwondr.com/community/search_ajax';

      $.ajax({
          url: url, // or example_ajax_obj.ajaxurl if using on frontend
          data: { data: data },
          type: "POST",
          dataType: "json",
          success: (data) => {
              // This outputs the result of the ajax request
              this.stories = data.items;
              console.log('stories', this.stories)
              callback();
          },
          error: (errorThrown) => {
              console.log(errorThrown);
          }
      }); 

    }
  }
}




// WEBPACK FOOTER //
// ./scripts/components/LocalStoriesMast.vue